import { render, staticRenderFns } from "./transparencia.vue?vue&type=template&id=4ceef753"
import script from "./transparencia.vue?vue&type=script&lang=js"
export * from "./transparencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports